export const aboutBusinessList = [
  {
    title: 'Nossa Visão',
    description:
      'Bem a nossa visão é ser uma das estrelas no mercado de soluções de TI. Ser a mais inesquecível e com qualidade sem ter procedência duvidosa para quem degustar de nossas soluções.',
  },
  {
    title: 'Nossa Missão',
    description:
      'A nossa missão de guerrilha é resolver a guerra que nossos clientes enfretam com tantas soluções prontas que não são tão boas para a guerra do dia a dia da empresa estamos aqui para trazer suprimento e múnição sob medida.',
  },

  {
    title: 'Nossos Valores',
    description:
      'Jura? Sem brincadeira agora, somos responsáveis entregamos resultados sob-medida, com transparência e flexibilidade.',
  },

  {
    title: 'Suas ideias, nossa experiência',
    description:
      'Bem general, somos a sua frente se tiver uma ideia a gente planeja, se mandar a gente faz. Contamos com você!',
  },

  {
    title: 'Somos a diferença.',
    description:
      'Todo mundo é igual? Não, não somos, criamos um ecossistema e relacionamentos duradouros. Mantemos nossa confiança e transparência até no pior dos casos.',
  },
]
